module.exports = __webpack_public_path__ + "img/logo-tradelinks-horizontal-azul.9652749b.png";